/* istanbul ignore file */
import { UntypedFormGroup } from '@angular/forms';

export class BulkSiteUploadOptionsSelectionModel {
    typeSelectionForm: UntypedFormGroup = new UntypedFormGroup({});
    applySiteTemplate = false;
    selectedSiteTemplateId = "";
    typeSelectionFormField = `bulkSiteUploadType`;
}
